export default "__VITE_ASSET__yCHuLFSH__"